import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { FunctionalRootState } from '@share/utils';
import { fetchCertificateTermsById } from '@share/store/slices';

export interface UseCertificateTermsResult {
  name: string;
  content: string;
  loading: boolean;
  error: string;
  refetch: () => void;
}

export function useCertificateTerms(guid: string): UseCertificateTermsResult {
  const dispatch = useDispatch();
  const { certificateTerms, loading, error } = useSelector(
    (state: FunctionalRootState) => state.certificateTermsStore,
  );

  const fetchTerms = useCallback(() => {
    if (!guid) {
      return;
    }

    dispatch(fetchCertificateTermsById(guid));
  }, [dispatch, guid]);

  useEffect(() => {
    fetchTerms();
  }, [fetchTerms]);

  return {
    name: certificateTerms?.name ?? '',
    content: certificateTerms?.content ?? '',
    loading,
    error: error?.detail || error?.title || '',
    refetch: fetchTerms,
  };
}
